import module from 'recursoshumanos/module.js'
import template from './template.html'

const diacriticosRegex = /[,.\u0300-\u036f]/g
const diacriticosEspacios = /\s+\s/g
const normalizar = (valor) => valor.normalize('NFD').replace(diacriticosRegex, '').replace(diacriticosEspacios, ' ').toUpperCase().trim()

export class RecursoshumanosDictamenIncidenciasListaComponent {
  operadoraId
  periodo
  clase
  registroPatronalId
  data = []
  q = null

  constructor (RecursoshumanosDictamenIncidencias) {
    this.RecursoshumanosDictamenIncidencias = RecursoshumanosDictamenIncidencias
  }

  $onInit () {
    this.resultados = [...this.data]
  }

  descargar () {
    if(this.descargando) return
    this.descargando = true
    let excel = 1
    this.RecursoshumanosDictamenIncidencias.get(this.operadoraId, this.periodo, this.clase, excel, this.registroPatronalId)
      .then(({data}) => (data.save()))
      .finally(() => (this.descargando = false))
  }

  filtrar () {
    let filtro = normalizar(this.q)
    this.resultados = this.data.filter(item => normalizar(item.nombre).indexOf(filtro) >= 0)
  }
}

module.component('recursoshumanosDictamenIncidenciasLista', {
  controller: RecursoshumanosDictamenIncidenciasListaComponent,
  template,
  bindings: {
    data: '<',
    operadoraId: '<',
    periodo: '<',
    clase: '<',
    registroPatronalId: '<',
  },
})



// WEBPACK FOOTER //
// ./src/recursoshumanos/components/dictamen/incidencias/lista/component.js